export default __webpack_public_path__ + "img/6ce24c58023cc2f8fd88fe9d219db6c6.svg";